









































































































































/*
  接口说明
  getCityList 获取市区管理信息分页列表
  saveOrUpdate 添加或者编辑市区信息
  deleteDistrict 删除市区信息
*/
import { Vue, Component } from "vue-property-decorator";
import Cookies from "js-cookie"; // 因为token 的问题引入cookies
import {
  getCityList,
  saveOrUpdate,
  deleteDistrict
} from "../../../api/cityManage";
//导入element-ui中form的类型接口
import { Form as ElForm } from "element-ui";
import { getToken } from "../../../utils/auth";
import {ruleNormal, rulePattern, validateMax12} from '@/utils/regxCustom'
import importAndExportMixin from "../../../mixins/importAndExport";

@Component({
  name: "cityManage",
  mixins: [importAndExportMixin],
  components: {
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
})
export default class extends Vue {
  private city: string = ""; //市区编号或名称
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private dialogFormVisible: boolean = false; //是否显示添加\编辑弹窗
  private editForm: object = {}; //添加\编辑弹窗的数据
  private dialogFormTitle: string = ""; //弹窗标题
  private uploadData = {progressId: -1}; // 文件上传入参

  private editFormRules: object = {
    districtCode: [
      ruleNormal("请输入市区编号"),
     { validator: validateMax12 }
    ],
    districtName: [
      ruleNormal("请输入市区名称"),
      rulePattern(/^[\u4e00-\u9fa5]{1,16}$/, "16位以内汉字市区名称")
    ]
  };

  created() {
    //获取列表数据
    this.getData();
  }

  //上传地址
  get uploadUrl() {
    return window.config.baseUrl4Shool + "/sysmange/district/upload";
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    let params = {
      current: this.pageNo,
      size: this.pageSize,
      districtCodeOrName: this.city
    };
    try {
      let res = await getCityList(params);
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      this.$message.error(error || "获取数据失败");
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    this.chooseIdArray = v.map((item: any) => {
      return item.districtId;
    });
  }

  //点击“添加”或“编辑”弹窗处理
  private showEditDialog(type: string, row?: any) {
    this.dialogFormTitle = type === "add" ? "添加市区" : "编辑市区";
    this.editForm = type === "modify" ? JSON.parse(JSON.stringify(row)) : {};
    //显示弹窗
    this.dialogFormVisible = true;
  }

  //新增/编辑-保存修改处理
  private saveEditHandle() {
    (this.$refs.editForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          await saveOrUpdate(this.editForm);
          this.$message.success("保存成功");
          this.dialogFormVisible = false;
          this.getData();
          (this.$refs.editForm as ElForm).clearValidate();
        } catch (error) {
          this.$message.error(error || "保存失败");
        }
      }
    });
  }

  // 取消
  private handleCancel() {
    (this.$refs.editForm as ElForm).clearValidate();
    this.dialogFormVisible = false;
  }

  //删除处理
  private deleteHandle() {
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      try {
        await deleteDistrict(this.chooseIdArray);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        this.$message.error(error || "删除失败");
      }
    });
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
